const GridModel = Backbone.Model.extend({
  initialize() {
    this.setButtons();
  },
  setButtons() {
    const buttonTypes = ['uploadToCloudinary', 'updateLotThumbs', 'edit', 'editLots', 'delete', 'duplicate'];
    const auctionBtns = ['uploadToCloudinary', 'updateLotThumbs', 'editLots'];
    _.forEach(buttonTypes, (type)=> {
      let html = `<a class="edit-btn" id="${type}"  data-id="${this.id}">${type}</a>`;
      if (type === 'edit') {
        if ((this.get('isEdit') === false) && (this.get('calendarID'))) {
          html = `<a class='reset-btn' id='reset' data-id="${this.get('calendarID')}">Reset</a>`;
        }
      }
      if (auctionBtns.indexOf(type) > -1) {
        if (type === 'updateLotThumbs') {
          if (this.get('auctionPublicID')) {
            html = `<a class='update-thumbs' id='auction${this.get('auctionPublicID')}' data-sale-number='${this.get('saleNumber')}'>Update</a>`;
          }
        }
        if (type === 'uploadToCloudinary') {
          if (this.get('auctionPublicID')) {
            html =
              `<a class='upload-cloudinary' id='Upload${this.get('saleNumber')}' data-sale-number='${
              this.get('saleNumber')}'>Upload</a>`;
          } else if (this.get('saleNumber') && this.get('lotNumberFull')) {
            html =
              `<a class='upload-cloudinary' id='Upload${this.get('lotNumberFull')}' data-sale-number='${
            this.get('saleNumber')}' data-lot-number='${this.get('lotNumberFull')}'>Upload Lot</a>`;
          }
        }
        if (type === 'editLots') {
          html = `<a id='edit' href='/Lot?SaleNumber=${this.get('saleNumber')}'>Lots</a>`;
        }
      }
      this.set(type, html);
    });
  },
  triggerUpdatedData(data) {
    this.set(data);
  },
  triggerArrayData({ prop, data }) {
    this.trigger('setArray', { prop, data });
  }
});

export default GridModel;
